<template>
  <div>
    <div class="d-flex justify-content-between mt-2 mb-4">
      <h3 class="text-danger mx-3">Re-order</h3>
      <div class="mx-1">
        <button
          class="btn btn-md btn-outline-hover-secondary kt-label-font-color-2"
          :disabled="isSaving"
          @click="cancel">Cancel</button>
        <button
          class="btn btn-md btn-secondary"
          :disabled="isSaving"
          @click="save(myArray)">
          <font-awesome-icon class="mr-1" :icon="['fas', 'spinner']" spin v-if="isSaving" />
          <font-awesome-icon class="mr-1" :icon="['fas', 'check']"  v-if="!isSaving" />
          Done re-order</button>
      </div>
    </div>

    <Draggable
      class="bg-light DraggableBox"
      v-model="myArray"
      :disabled="isSaving"
      @start="isDragging=true"
      @end="isDragging=false"
      v-bind="dragOptions">
      <TabItineraryReorderItem
        v-for="(day, index) in myArray"
        :key="index"
        :data="day"
        :selected="daySelected" />
    </Draggable>
  </div>
</template>

<script>
import Draggable from 'vuedraggable'
import TabItineraryReorderItem from '@/components/opportunity-edit/TabItineraryReorderItem.vue'

export default {
  name: 'TabItineraryReorder',
  components: { Draggable, TabItineraryReorderItem },
  data () {
    return {
      isSaving: false,
      isDragging: false,
      myArray: []
    }
  },
  props: {
    days: {
      type: Array,
      required: true
    },
    daySelected: {
      // Day selected
      type: Object,
      required: true
    }
  },
  created () {
    this.myArray = this.days
  },
  computed: {
    dragOptions () {
      return {
        animation: 300,
        group: 'itinerary',
        disabled: false,
        ghostClass: 'ghost'
      }
    }
  },
  methods: {
    cancel () {
      this.myArray = this.days
      this.$emit('onCancelReorder')
    },
    save (newOrder) {
      this.isSaving = true
      this.$emit('onSaveReorder', newOrder)
    }
  }
}
</script>

<style lang="scss" scoped>
.DraggableBox {
  overflow-y: scroll;
  padding: 0px 10px 15px 10px;
  height: 450px;
  z-index: 1;
}

.ghost {
  opacity: .6;
}
</style>
